import * as React from "react";
import {cx} from "emotion";

import "./viewing.scss";

import {cs}               from "@Common/react/chain-services";
import {keyed}            from "@Common/react/keyed";
import {Static2}          from "@Common/react/static-2";
import {UseState}         from "@Common/react/use-state";
import {ErrorHighlighter} from "@Common/ui-components/light/error-highlighter";
import {scrollIntoView}   from "@Common/ui-components/light/scroll-into-view";

import {getLines} from "../common/get-lines";

export const Viewing = ({saved, onEdit, next}) => cs(
    ["eh", (_, next) => ErrorHighlighter({next})],
    ["domRef", (_, next) => Static2({next})],
    ["showErrors", (_, next) => UseState({next})],
    ({showErrors, eh, domRef}) => next({
        highlightErrors: () => {
            eh.start();
            scrollIntoView(domRef.get());
            showErrors.onChange(true);
        },
        render: ({showErrors: forcedShowErrors}) => cs(
            keyed("viewing"),
            ({}, next) => (
                <div className={cx("viewing-5cr", eh.css)} ref={domRef.set}>
                    {next()}
                </div>
            ),
            ({}) => !saved ? <>
                <div className="left">
                    <div className="title" xd-qa-type="label" xd-qa-name="Permit not found">
                        Permit not found
                    </div>

                    <div className="content no-permit" >
                        <div className="message" xd-qa-type="label" xd-qa-name="No Permit On File">
                            You do not have a permit on file
                        </div>
                        <a
                            className="link"
                            href="https://pe.usps.com/businessmail101?ViewName=PermitApplication"
                            target="_blank"
                            xd-qa-type="link"
                            xd-qa-name="How to apply for a permit"
                        >
                            How to Apply for a Permit <i className="fa fa-external-link"/>
                        </a>

                        {(showErrors.value || forcedShowErrors) && (
                            <div className={cx("error")} xd-qa-type="label" xd-qa-name="Bulk Mail Error">
                                Bulk Mail Permit is selected. Please add permit or de-select option to continue.
                            </div>
                        )}

                        <div className="actions">
                            <button {...{
                                onClick: onEdit,
                            }}
                                xd-qa-type="button"
                                xd-qa-name="Add Bulk Mail"
                            >ADD</button>
                        </div>
                    </div>
                </div>


                <div className="sample">
                    <div className="title" xd-qa-type="label" xd-qa-name="Sample">
                        Sample:
                    </div>

                    <textarea {...{
                        value: sampleLines.join("\n"),
                        onChange: () => {},
                    }}
                        xd-qa-type="textarea"
                        xd-qa-name="Sample Text"
                    />
                </div>
            </> : <>
                <div className="left">
                    <div className="title" xd-qa-type="label" xd-qa-name="Permit ready to use">
                        Permit ready to use
                    </div>

                    <div className="content has-permit">
                        <div className="message" xd-qa-type="label" xd-qa-name="Bulk Mail Permit Saved">
                            You have your bulk mail permit saved
                        </div>
                        <div className="question" xd-qa-type="label" xd-qa-name="Do you want to update it">
                            Do you want to update it?
                        </div>

                        <div className="actions">
                            <button {...{
                                onClick: onEdit,
                            }}
                                xd-qa-type="button"
                                xd-qa-name="Edit Bulk Mail"
                            >EDIT</button>
                        </div>
                    </div>
                </div>

                <div className="sample">
                    <div className="title" xd-qa-type="label" xd-qa-name="Sample">
                        Sample:
                    </div>

                    <textarea {...{
                        value: getLines(saved).join("\n"),

                        onChange: () => {},
                    }}
                        xd-qa-type="textarea"
                        xd-qa-name="Permit Text"
                    />
                </div>
            </>,
        ),
    })
);

const sampleLines = [
    "FIRST-CLASS MAIL",
    "U.S. POSTAGE",
    "PAID",
    "FORT WORTH, TX",
    "PERMIT NO.123",
];
